import React from 'react';

export default function IconXLS() {
  return (
    <svg
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24px"
      height="24px"
    >
      <path d="M2 5.82v12.36c0 .477.336.887.804.981l8 1.6C11.423 20.885 12 20.411 12 19.78V4.22c0-.631-.577-1.104-1.196-.981l-8 1.6C2.336 4.933 2 5.343 2 5.82zM8.751 15.703c-.292 0-.558-.17-.68-.436l-.913-1.979c-.042-.085-.092-.256-.133-.494H7.009c-.025.114-.075.285-.15.514l-.931 1.988c-.116.248-.366.407-.64.407H5.201c-.539 0-.879-.579-.618-1.05l1.477-2.658L4.748 9.422C4.486 8.907 4.86 8.297 5.438 8.297h0c.312 0 .594.188.714.476l.724 1.739c.075.181.133.39.191.628h.025c.033-.143.099-.361.2-.646l.84-1.79c.116-.248.366-.407.64-.407h0c.532 0 .873.566.625 1.036l-1.389 2.633 1.406 2.634C9.678 15.1 9.317 15.703 8.751 15.703L8.751 15.703zM21 5h-7v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h7c.552 0 1-.448 1-1V6C22 5.448 21.552 5 21 5zM20 17h-2v-2h2V17zM20 13h-2v-2h2V13zM20 9h-2V7h2V9z" />
    </svg>
  );
}
